import { useQuery } from '@tanstack/react-query';
import { messagingService } from 'v2/services/messaging';

export const useMessageChats = () => {
  const { data, isLoading, isFetching, error, refetch } = useQuery({
    queryKey: ['messages', 'chats'],
    queryFn: () => messagingService.getChats(),
    refetchInterval: 30000,
    refetchOnWindowFocus: true,
    refetchOnMount: true
  });

  return {
    chats: data?.data?.chats || [],
    isLoading,
    isFetching,
    error,
    refetch
  };
};
